
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Message extends Vue {
  private radio = 'warning'

  created () {
    this.radio = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
  }

  handleChange () {
    const path = `/message/${this.radio}`
    this.$router.replace({ path: path })
  }
}
